import React from "react";
import { Panel } from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";
import { UpdateKeywordGroup } from "../Elements/AscElements/KeywordGroupElements";
import { ViewCompanyElement } from "../Elements/AscElements/CompanyElements";
import AscComponent from "../../components/AscComponent";

/**
 * キーワードグループ編集画面
 */
export default class KeywordGroupUpdateModal extends AscComponent {
    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}>
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>
                            {this.props.langText.Body.KeywordGroupInfo}
                        </Panel.Title>
                    </Panel.Heading>
                    
                    <Panel.Body>
                        <ViewCompanyElement
                            state={this.props.state}
                            langText={this.props.langText}>
                        </ViewCompanyElement>
                        <UpdateKeywordGroup
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange_Limit={this.props.onTextChange_Limit}
                            charaLimit={this.props.charaLimit}
                            validationHandle={this.props.validationHandle}
                            onSelectChange={this.props.onSelectChange}
                            onMultiValueFormTextChange={this.props.onMultiValueFormTextChange}
                            onMultiValueFormSizeChange={this.props.onMultiValueFormSizeChange}
                            onBlurHandle={this.props.onBlurHandle}
                            checkDuplicateKeywordGroupName={this.props.checkDuplicateKeywordGroupName}
                            boardWidth={this.props.boardWidth}>
                        </UpdateKeywordGroup>
                    </Panel.Body>
                </Panel>
            </AscModal>
        );
    }
}
